var POST_LOGIN_PATH_KEY = "participe.postLoginPath";
var isSafeInternalPath = function (path) {
    return path.startsWith("/") && !path.startsWith("//") && !path.includes("://");
};
var getStorage = function () {
    if (typeof window === "undefined") {
        return null;
    }
    return window.localStorage;
};
export var setPostLoginPath = function (path) {
    var storage = getStorage();
    if (!storage || !isSafeInternalPath(path)) {
        return;
    }
    storage.setItem(POST_LOGIN_PATH_KEY, path);
};
export var peekPostLoginPath = function () {
    var storage = getStorage();
    if (!storage) {
        return null;
    }
    var path = storage.getItem(POST_LOGIN_PATH_KEY);
    return path && isSafeInternalPath(path) ? path : null;
};
export var consumePostLoginPath = function () {
    var path = peekPostLoginPath();
    clearPostLoginPath();
    return path;
};
export var clearPostLoginPath = function () {
    var storage = getStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(POST_LOGIN_PATH_KEY);
    if (typeof window !== "undefined") {
        window.sessionStorage.removeItem(POST_LOGIN_PATH_KEY);
    }
};
